export default "__VITE_ASSET__dtJlb7WxA$YTmj6$fFe_Ow__";